import React from 'react'
import Breadcrumb from '../Breadcrumb/index'
import Header from '../Header';
import FooterTwo from '../Footer/FooterTwo';

const Partner=({title="",description="",partners=[]})=>{

    return (
        <>
        <Header
                topbarEnable='enable'
            />
        <Breadcrumb pageTitle={title}/>
        <section className='container pb-5'>
            <p className='col-10 m-auto my-5 text-center fs-5'>{description}</p>
            <div className='row row-cols-2 row-cols-md-4 g-3 mb-5'>
              {
                partners?.map((item,idx)=>(
                    <>
                     <div key={idx} className='col p-2'>
                                <div className='rounded-3 d-flex justify-content-center align-items-center' style={{border:"1px solid black",height:"140px"}} >
                                 <img src={item?.logoUrl} width={150} height={150} className='object-fit-contain' style={{width:"100%",height:"100%",objectFit:"contain"}}/>
                                </div>
                     </div>
                    {/* <div key={idx} className='col p-2'>
                        <img src={item?.logoUrl} className='img-fluid'/>
                    </div> */}
                    </>
                ))
              }
            </div>
        </section>
        <FooterTwo/>
        </>
    )


};

export default Partner;